import "./LoaderLoop.css";

/**
 * LoaderLoop — the one loading glyph of the system.
 * Three soft mint dots breathing in sequence. Pure CSS.
 *
 * Used by `GlobalLoader` (screen) and `ContentLoader` (content). Use it bare
 * inside a control (e.g. a submitting button) with size="xs"; there it
 * inherits the button's text color.
 *
 * @param {"xs"|"sm"|"md"|"lg"} [size="md"]
 * @param {string} [className]
 */
function LoaderLoop({ size = "md", className = "" }) {
  return (
    <span className={`ck-loop ck-loop--${size} ${className}`.trim()} aria-hidden="true">
      <span className="ck-loop-dot" />
      <span className="ck-loop-dot" />
      <span className="ck-loop-dot" />
    </span>
  );
}

export default LoaderLoop;
